export default __webpack_public_path__ + "static/profile-icon-33cff0619bb62fca8481825cdb347073.jpg";